import { domtify } from "@/core.js"

domtify.noop = () => {}
